import HBSwiper from "@/components/HBSwiper";
import Image from "@/components/Image";
import { TrackerA } from "@/components/Tracker";
import { getImageSrc2x } from "@/utils/imageUrl";
import { useUpdateEffect } from "ahooks";
import classNames from "classnames";
import { useRef } from "react";
import styles from "./index.module.less";

interface IItem {
  word: string;
  file: IPinFile;
  href: string;
}

interface RelationWordsViewProps {
  relationList: IItem[];

  onClickKeyword?: (
    evt: React.MouseEvent<HTMLAnchorElement>,
    item: IItem
  ) => void;

  customTrackDataFn?: (item: IItem, index: number) => Record<string, any>;
}

export function RelationWordsView({
  relationList,
  onClickKeyword,
  customTrackDataFn,
}: RelationWordsViewProps) {
  const swiperRef = useRef(null);
  useUpdateEffect(() => {
    // 内容更新，滚动到顶部
    swiperRef.current?.reset();
  }, [relationList]);

  if (!(relationList?.length > 0)) {
    return null;
  }

  return (
    <div className={classNames(styles.swiperContent, styles.new)}>
      <HBSwiper
        className={styles.swiper}
        iconClassName={styles.icon}
        ref={swiperRef}
      >
        <div className={styles.list}>
          {relationList?.map((item, index) => (
            <TrackerA
              key={index}
              className={styles.searchCard}
              onClick={(evt) => onClickKeyword?.(evt, item)}
              href={item.href}
              {...(customTrackDataFn?.(item, index) || {
                "data-gd-expose": "button_expose",
                "data-gd-click": "button_click",
                "data-button-name": item.word,
                "data-content-source": "搜索推荐词",
                "data-unique-id": item.word,
              })}
              title={item.word}
              target="_blank"
            >
              {item.file && (
                <Image
                  {...getImageSrc2x(item.file, { width: 32 })}
                  alt={item.word}
                  width={32}
                  height={32}
                />
              )}
              <span className={styles.word}>{item.word}</span>
            </TrackerA>
          ))}
        </div>
      </HBSwiper>
    </div>
  );
}
